import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material";

import Navbar from "./components/common/Navbar";
import Sidebar from "./components/common/sidebar/Sidebar";

import Login from "./pages/loginPage/Login";

import CssBaseline from "@mui/material/CssBaseline";
import { darkTheme, lightTheme } from "./theme";
import PageRoutes from "./routes/PageRoutes";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 0),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

function App() {
  const { isAuthenticated, user } = useSelector((state) => state.login);
  const { mode } = useSelector((state) => state.mode);

  return (
    <>
      <ThemeProvider theme={mode === "light" ? lightTheme : darkTheme}>
        <CssBaseline />
        {isAuthenticated || user ? (
          <Box>
            <Navbar />
            <Box
              sx={{
                display: { sm: "flex", xs: "block" },
              }}
            >
              <Box
                sx={{
                  position: { lg: "inherit", md: "absolute" },
                }}
              >
                <Sidebar />
              </Box>
              <Box
                sx={{
                  position: "relative",
                  flexGrow: 1,
                  overflow: "auto",
                  mt: 2,
                  px: { lg: 4, sm: 3, xs: 2 },
                  py: { lg: 5, sm: 4, xs: 3 },
                  ml: { md: 6.5, lg: "inherit" },
                }}
              >
                <DrawerHeader />
                <PageRoutes />
              </Box>
            </Box>
          </Box>
        ) : (
          <Login></Login>
        )}
      </ThemeProvider>
    </>
  );
}

export default App;
